import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { initAnalytics } from './analytics';
import GoogleAnalytics from './GoogleAnalytics';

initAnalytics();

ReactDOM.createRoot(document.getElementById("root")!).render(
    <BrowserRouter>
        <GoogleAnalytics />
        <App />
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

